// src/components/Footer.js
import React from 'react';
import { Icons } from './Icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <a href="/" className="logo">
              <Icons.Shield />
              <span>Atri Bot</span>
            </a>
            <p>Продвинутый модератор для Telegram-чатов</p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4>Навигация</h4>
              <a href="#features">Возможности</a>
              <a href="#commands">Команды</a>
              <a href="#settings">Настройки</a>
              <a href="#faq">FAQ</a>
            </div>
            <div className="footer-column">
              <h4>Контакты</h4>
              <a href="https://t.me/AtriGuard_bot">Бот</a>
              <a href="https://t.me/littlebigcoder">Разработчик</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Atri Bot. Все права защищены.</p>
          <div className="footer-socials">
            <a href="https://t.me/AtriGuard_bot">
              <Icons.Telegram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;